import { makeObservable, observable } from "mobx";
import { SyncTrunk } from "mobx-sync";
import React from "react";

class RootStore {
	@observable background = false;
	@observable open = true;
	@observable paneKey = "Button";
	@observable skin = "CentricBlue";

	constructor() {
		makeObservable(this);
	}
}

export const rootStore = new RootStore();
export const RootStoreContext = React.createContext(rootStore);

export function useStore(): RootStore {
	return React.useContext(RootStoreContext);
}

// sync store with local storage
const trunk = new SyncTrunk(rootStore, { storageKey: "csiDesignState" });
trunk.init();


